import { type FormEvent, useState } from "react";
import { errorMessage } from "@/lib/api/client";
import { useLogin } from "@/lib/api/queries";
import { useAuth } from "@/lib/auth";
import { Icon } from "@/components/icon/Icon";
import { Alert, Button, Card, TextField } from "@/components/ui";

export function Login() {
  const { signIn } = useAuth();
  const login = useLogin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  function submit(event: FormEvent) {
    event.preventDefault();
    login.mutate({ username, password }, { onSuccess: (data) => signIn(data.access_token) });
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background-alternative px-4">
      <Card style={{ width: "100%", maxWidth: 400 }}>
        <form onSubmit={submit} className="flex flex-col gap-5 p-2">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <Icon name="sparkleFill" size={22} style={{ color: "var(--primary-normal)" }} />
              <h1 className="text-headline-2 font-bold text-label-strong">llm-logger</h1>
            </div>
            <p className="text-label-2 text-label-alternative">관리자 계정으로 로그인해 주세요.</p>
          </div>

          <TextField
            label="아이디"
            name="username"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
          />
          <TextField
            label="비밀번호"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />

          {login.isError && <Alert tone="negative" title="로그인하지 못했어요">{errorMessage(login.error)}</Alert>}

          <Button type="submit" size="large" fullWidth disabled={login.isPending}>
            {login.isPending ? "로그인 중…" : "로그인"}
          </Button>

          <p className="text-caption-1 text-label-assistive">
            수집(인제스트)은 서비스별 API 키를 쓰고, 이 로그인은 대시보드 전용이에요.
          </p>
        </form>
      </Card>
    </div>
  );
}
